import generateFields from './inputs';

export default (data, i18n, formType) => {
  const generatedFields = generateFields(data, i18n, formType);

  return {
    form: generatedFields,
  };
};
